import { createContext, useContext } from "react";

/**
 * Fornece a(s) URL(s) do logo personalizado do professor para todos os
 * modais que usam useLogoSrc() -- ModalHeader, WorkoutSummaryModal.
 *
 * Formato: { dark, light } -- não uma string única. `light` é uma variante
 * OPCIONAL (R248): quando o professor só enviou um logo (comportamento de
 * sempre), light vem null e cada consumidor decide sozinho usar dark nos
 * dois modos -- mesmo mecanismo de troca do wordmark padrão do TreinoNexo
 * (DEFAULT_LOGO_DARK/DEFAULT_LOGO_LIGHT em ModalHeader.jsx), só que a
 * variante clara é opcional aqui (o wordmark padrão sempre tem as duas).
 * dark/light null nos dois = sem logo customizado, usa o padrão TreinoNexo.
 */
const DEFAULT_VALUE = { dark: null, light: null };

export const LogoContext = createContext(DEFAULT_VALUE);

export function useLogoSrc() {
  return useContext(LogoContext);
}
